import { styled, useTheme, alpha } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import * as Maticons from '@mui/icons-material'
import CachedIcon from '@mui/icons-material/Cached'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import MenuIcon from '@mui/icons-material/Menu'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import { LoadingButton } from '@mui/lab'
import MuiDrawer from '@mui/material/Drawer'
import MuiAppBar from '@mui/material/AppBar'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import {
  Alert,
  Box,
  Button,
  Collapse,
  CssBaseline,
  Divider,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Snackbar,
  TextField,
  Toolbar,
  Tooltip,
  useMediaQuery,
  Avatar,
  AvatarGroup,
  Autocomplete,
  Dialog
} from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import DataTwin_Logo_ from '../assets/datatwinLogonew.png'
import DatatwinIcon from '../assets/DatatwinIcon.png'
import ApiConstants from '../config'

import { AccountCircle, Visibility, VisibilityOff } from '@mui/icons-material'
import CryptoJS from 'crypto-js'
import { Spinner } from 'react-bootstrap'
import environment from '../config.json'
import { getRequest, postRequest } from '../globalhelper/helper'
import { login, logout } from '../redux/Login/loginActions'
import { navUrl, setMenuTree, setOrganizations } from '../redux/Common/commonActions'
import ORGDialogbox from './ORGDialogbox'
import { flushChatbotItems } from '../redux/SelectApp/saActions'
import store from '../store'
import { toggleDrawer } from '../redux/SideBarDrawer/SideBarDrawerAction'
import { DialogActions, DialogContent, DialogTitle, Grid } from '@material-ui/core'
import globalhelper from '../helper/globalhelper'
const ADMIN_USERS = [
  '#USR#hariprakash.babu@oneintegral.com',
  '#USR#dinesh.kumar@oneintegral.com',
  '#USR#usha.v@datatwin.ai',
  '#USR#raghavan@oneintegral.com'
]


const drawerWidth = 260

const openedMixin = theme => ({
  width: drawerWidth,
  background: '#0f172a',
  color: '#ffffff', // Pure white text
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  border: 'none',
  boxShadow: '10px 0 50px rgba(0, 0, 0, 0.2)'
})

const closedMixin = theme => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  background: '#0f172a',
  color: '#ffffff',
  border: 'none',
  boxShadow: '10px 0 50px rgba(0, 0, 0, 0.2)',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`
  }
})

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}))

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open'
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 2,
  backgroundColor: '#ffffff',
  color: '#475569',
  boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
  borderBottom: `1px solid ${alpha('#000000', 0.04)}`,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  marginLeft: 72,
  width: `calc(100% - 72px)`,
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}))

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: prop => prop !== 'open'
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  },
  '& .MuiDrawer-paper': {
    position: 'fixed',
    height: '100vh',
    border: 'none',
    background: '#0f172a',
    boxShadow: '10px 0 50px rgba(0, 0, 0, 0.2)',
    overflowX: 'hidden',
    overflowY: 'auto'
  },
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme)
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme)
  })
}))

const StyledListItemButton = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'open'
})(({ theme, active, open }) => ({
  margin: open ? '4px 12px' : '4px auto',
  borderRadius: '24px', // More flexible than 50px for multi-line
  minHeight: 44,
  width: open ? 'auto' : 44,
  padding: open ? '10px 20px' : 0,
  justifyContent: open ? 'initial' : 'center',
  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  color: '#ffffff', // Pure white text
  '&:hover': {
    background: alpha('#ffffff', 0.05),
    color: '#ffffff',
    '& .MuiListItemIcon-root': {
      color: '#ffffff'
    }
  },
  ...(active && {
    background: '#4f46e5', // Professional Indigo matching dashboard accents
    color: '#ffffff',
    boxShadow: `0 4px 15px ${alpha('#4f46e5', 0.4)}`,
    '&:hover': {
      background: '#4338ca',
      color: '#ffffff',
      '& .MuiListItemIcon-root': {
        color: '#ffffff'
      }
    },
    '& .MuiListItemIcon-root': {
      color: '#ffffff',
    }
  })
}))

const StyledIcon = styled('div')(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'inherit',
  transition: 'color 0.2s',
  '& svg': {
    fontSize: '22px'
  }
}))

// useStyles removed in favor of styled components and sx prop

function ResponsiveDrawer(props) {
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [anchorEl, setAnchorEl] = useState(null)
  const [mobileOpen, setMobileOpen] = useState(false)
  const [activeMenuIndex, setActiveMenuIndex] = useState(null)
  const [openDialog, setOpenDialog] = useState(false)
  const [menus, setMenus] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [showOrgModal, setShowOrgModal] = useState(false)
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false)
  const [showMobileSearch, setShowMobileSearch] = useState(false)
  const isMobileSearch = useMediaQuery('(max-width:900px)')

  const open = useSelector(state => state.layout.drawerOpen)
  const pagename = useSelector(state => state.common.pagename)
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMounted = useRef(true)

  const [password, setPassword] = useState({
    newPassword: '',
    oldPassword: '',
    confirmNewPassword: '',
    visibility: {
      oldOPassword: false,
      newPassword: false,
      confirmNewPassword: false
    },
    error: {
      newPasswordError: '',
      oldPasswordError: '',
      confirmNewPasswordError: ''
    },
    conditionsMet: {
      minLength: false,
      hasUpperCase: false,
      hasLowerCase: false,
      hasNumbers: false,
      hasSpecialChars: false
    },
    invalid: true,
    loading: false
  })

  const bottom_menu = {
    name: 'My Apps',
    url: '/',
    icon: 'Apps'
  }

  useEffect(() => {
    isMounted.current = true
    const menuInterval = setInterval(() => {
      if (isMounted.current) {
        setMenuTree()
      }
    }, 1000)

    return () => {
      isMounted.current = false
      clearInterval(menuInterval)
    }
  }, [])

  useEffect(() => {
    if (localStorage.getItem('module') !== '') {
      getMenus()
    }
  }, [localStorage.getItem('module')])

  const getMenus = () => {
    if (!isMounted.current) return
    setMenus([])
    getRequest(
      'api/module/getMenus?product=' + localStorage.getItem('module')
    ).then(result => {
      if (isMounted.current && result.res.status === 'success') {
        setMenus(result.res.data)
        localStorage.setItem('menuTree', JSON.stringify(result.res.data))
      }
    })
  }

  const handleDrawerToggle = () => {
    dispatch(toggleDrawer())
  }

  const handleDrawerToggleMobile = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseAnc = () => {
    setAnchorEl(null)
  }

  const handleErrorClose = (event, reason) => {
    if (reason === 'clickaway') return
    setErrorMessage('')
  }

  const handleSuccessClose = (event, reason) => {
    if (reason === 'clickaway') return
    setSuccessMessage('')
  }

  const handleOpen = () => setOpenDialog(true)
  const handleClose = () => {
    setOpenDialog(false)
    setPassword(prev => ({
      ...prev,
      newPassword: '',
      oldPassword: '',
      confirmNewPassword: '',
      loading: false,
      invalid: true
    }))
  }

  const onPasswordChange = (field, value) => {
    setPassword(prev => {
      const updated = { ...prev, [field]: value }
      const { newPassword, oldPassword, confirmNewPassword } = updated

      const minLength = newPassword.length >= 8
      const hasUpperCase = /[A-Z]/.test(newPassword)
      const hasLowerCase = /[a-z]/.test(newPassword)
      const hasNumbers = /[0-9]/.test(newPassword)
      const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(newPassword)

      updated.conditionsMet = { minLength, hasUpperCase, hasLowerCase, hasNumbers, hasSpecialChars }

      const passwordValid = minLength && hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChars
      const match = confirmNewPassword === newPassword

      updated.invalid = !passwordValid || !oldPassword || !confirmNewPassword || !match
      return updated
    })
  }

  const onVisibilityChange = field => {
    setPassword(prev => ({
      ...prev,
      visibility: { ...prev.visibility, [field]: !prev.visibility[field] }
    }))
  }

  const handleChangePassword = () => {
    setPassword(prev => ({ ...prev, loading: true }))
    const payload = {
      password: CryptoJS.AES.encrypt(password.oldPassword, environment['encryption-key']).toString(),
      newPassword: CryptoJS.AES.encrypt(password.newPassword, environment['encryption-key']).toString()
    }
    postRequest('api/auth/changePassWhenLogedIn', payload).then(() => {
      setSuccessMessage('Password updated successfully')
      handleClose()
    }).catch(() => {
      setErrorMessage('Failed to update password')
      setPassword(prev => ({ ...prev, loading: false }))
    })
  }

  const handleClick = (mn, index, menuType, menuName) => {
    sessionStorage.setItem('pageName', menuName)
    if (mn.group) {
      const newMenus = [...menus]
      let isExpanding = false;
      if (menuType === 'menu') {
        newMenus.forEach((m, i) => {
          if (i === index) {
            m.open = !m.open
            isExpanding = m.open;
          }
          else m.open = false
        })
      } else {
        newMenus.forEach(m => {
          if (m.group && m.submenus) {
            m.submenus.forEach((sm, i) => {
              if (sm.name === mn.name) {
                sm.open = !sm.open
                isExpanding = sm.open;
              }
              else sm.open = false
            })
          }
        })
      }
      setMenus(newMenus)
      if (isExpanding) {
        setTimeout(() => {
          const sidebar = document.querySelector('.sidebar-scroll');
          const targetId = menuType === 'menu' ? `menu-item-${index}` : `submenu-item-${index}`;
          const activeItem = document.getElementById(targetId);
          if (sidebar && activeItem) {
            sidebar.scrollTo({ top: activeItem.offsetTop - 10, behavior: 'smooth' });
          } else if (sidebar) {
            sidebar.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 200);
      }
    } else {
      mn.pagetype && mn.pagetype === 'dynamic'
        ? localStorage.setItem('pagename', mn.pagename || '')
        : localStorage.setItem('pagename', '')
      localStorage.setItem('dashboard_id', mn.dashboard_id || '')
      props.navUrl(mn.url, mn.name)
    }
  }

  const logout = ev => {
    ev.preventDefault()
    handleCloseAnc()
    setOpenLogoutDialog(true)
  }

  const confirmLogout = () => {
    setOpenLogoutDialog(false)
    props.logout()
    props.flushChatbotItems()
  }

  const refreshPage = () => {
    window.location.reload()
  }

  const state1 = store.getState()
  const userData = state1.login.userData

  // Helper to flatten menu for search
  const flattenMenus = (items, prefix = '') => {
    let flat = []
    items.forEach(item => {
      const label = prefix ? `${prefix} > ${item.name}` : item.name
      if (item.group && item.submenus) {
        flat = [...flat, ...flattenMenus(item.submenus, label)]
      } else {
        flat.push({ ...item, flatLabel: label })
      }
    })
    return flat
  }

  const searchableMenus = flattenMenus(menus)

  const handleSwitchOrg = () => {
    const tenants = userData.USR_Tenants || []
    if (tenants.length > 0) {
      dispatch(setOrganizations(tenants))
      setShowOrgModal(true)
    } else {
      setErrorMessage('No other organizations found for this account.')
    }
  }

  const drawer = (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: '#0f172a' }}>
      {props.type === '' ? (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <List sx={{ px: 1 }}>
            <StyledListItemButton
              active={activeMenuIndex === 1}
              open={open}
              onClick={() => {
                localStorage.setItem('go_to_landing_page', '0')
                setActiveMenuIndex(1)
                handleClick(bottom_menu, 1, '', 'My Apps')
              }}
            >
              <Tooltip title={open ? '' : 'My Apps'} placement='right' arrow>
                <ListItemIcon sx={{ minWidth: open ? 40 : 'auto', color: 'inherit', justifyContent: 'center' }}>
                  <StyledIcon active={activeMenuIndex === 1}>
                    <Maticons.Apps />
                  </StyledIcon>
                </ListItemIcon>
              </Tooltip>
              {open && (
                <ListItemText
                  primary='My Apps'
                  sx={{
                    '& .MuiTypography-root': {
                      fontWeight: activeMenuIndex === 1 ? 600 : 400,
                      fontSize: '0.85rem',
                      color: '#ffffff'
                    }
                  }}
                />
              )}
            </StyledListItemButton>
            <Divider sx={{ my: 1, borderColor: alpha('#ffffff', 0.1) }} />
          </List>
        </Box>
      ) : (
        <>
          <List className='sidebar-scroll' sx={{ flex: 1, px: 1, overflowY: 'auto', overflowX: 'hidden' }}>
            {menus.length > 0 ? (
              menus.map((menu, index) => {
                const IconToRender = Maticons[menu.icon] || Maticons.Menu
                const isActive = activeMenuIndex === index

                return (
                  <React.Fragment key={index}>
                    <StyledListItemButton
                      id={`menu-item-${index}`}
                      active={isActive}
                      open={open}
                      onClick={() => {
                        setActiveMenuIndex(index)
                        handleClick(menu, index, 'menu', menu.name)
                      }}
                    >
                      <Tooltip title={open ? '' : menu.name} placement='right' arrow>
                        <ListItemIcon sx={{ minWidth: open ? 40 : 'auto', color: 'inherit', justifyContent: 'center' }}>
                          <StyledIcon active={isActive}>
                            <IconToRender />
                          </StyledIcon>
                        </ListItemIcon>
                      </Tooltip>
                      {open && (
                        <>
                          <ListItemText
                            primary={menu.name}
                            sx={{
                              '& .MuiTypography-root': {
                                fontWeight: isActive ? 600 : 400,
                                fontSize: '0.85rem',
                                color: isActive ? '#ffffff' : '#ffffff',
                                whiteSpace: 'normal',
                                lineHeight: 1.2,
                                py: 0.5,
                                overflow: 'visible',
                                textOverflow: 'initial'
                              }
                            }}
                          />
                          {menu.group && (
                            isActive ? <ExpandLess sx={{ fontSize: '1.2rem', opacity: 0.7, color: '#ffffff' }} /> : <ExpandMore sx={{ fontSize: '1.2rem', opacity: 0.7, color: '#ffffff' }} />
                          )}
                        </>
                      )}
                    </StyledListItemButton>

                    {menu.group && menu.submenus && (
                      <Collapse in={menu.open && open} timeout='auto' unmountOnExit>
                        <List component='div' disablePadding sx={{
                          pl: 4,
                          position: 'relative',
                          '&:before': {
                            content: '""',
                            position: 'absolute',
                            left: '26px',
                            top: 0,
                            bottom: '20px',
                            width: '1px',
                            background: alpha('#ffffff', 0.1)
                          }
                        }}>
                          {menu.submenus.map((sm, key) => {
                            const SubMenuIcon = Maticons[sm.icon] || Maticons.Label
                            const isSubActive = activeMenuIndex === `sub-${key}`

                            return (
                              <StyledListItemButton
                                id={`submenu-item-${key}`}
                                key={key}
                                active={isSubActive}
                                open={open}
                                sx={{
                                  py: 0.5,
                                  minHeight: 36,
                                  margin: open ? '2px 12px' : '2px auto',
                                  width: open ? 'auto' : 36,
                                  padding: open ? '4px 12px' : 0,
                                  justifyContent: open ? 'initial' : 'center',
                                  '&:before': {
                                    content: open ? '""' : 'none',
                                    position: 'absolute',
                                    left: '-14px',
                                    top: '50%',
                                    width: '10px',
                                    height: '1px',
                                    background: alpha('#ffffff', 0.1)
                                  }
                                }}
                                onClick={() => {
                                  setActiveMenuIndex(`sub-${key}`)
                                  handleClick(sm, key, 'sm', `${menu.name}/${sm.name}`)
                                }}
                              >
                                <ListItemIcon sx={{ minWidth: open ? 32 : 'auto', color: 'inherit', justifyContent: 'center' }}>
                                  <StyledIcon active={isSubActive}>
                                    <SubMenuIcon sx={{ fontSize: '1rem' }} />
                                  </StyledIcon>
                                </ListItemIcon>
                                <ListItemText
                                  primary={sm.name}
                                  sx={{
                                    '& .MuiTypography-root': {
                                      fontSize: '0.8rem',
                                      color: '#ffffff',
                                      fontWeight: isSubActive ? 600 : 400,
                                      whiteSpace: 'normal',
                                      lineHeight: 1.2,
                                      py: 0.5
                                    }
                                  }}
                                />
                              </StyledListItemButton>
                            )
                          })}
                        </List>
                      </Collapse>
                    )}
                  </React.Fragment>
                )
              })
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <Spinner animation='border' size='sm' style={{ color: '#7c3aed' }} />
              </Box>
            )}
          </List>

          {props.type !== '' && (
            <Box sx={{ p: 1, borderTop: `1px solid ${alpha('#ffffff', 0.1)}`, backgroundColor: '#0f172a' }}>
              <StyledListItemButton
                active={activeMenuIndex === 'bottom'}
                open={open}
                onClick={() => {
                  localStorage.setItem('go_to_landing_page', '0')
                  setActiveMenuIndex('bottom')
                  handleClick(bottom_menu, 1, '', 'My Apps')
                }}
              >
                <ListItemIcon sx={{ minWidth: open ? 40 : 'auto', color: 'inherit', justifyContent: 'center' }}>
                  <StyledIcon active={activeMenuIndex === 'bottom'}>
                    <Maticons.Apps />
                  </StyledIcon>
                </ListItemIcon>
                {open && (
                  <ListItemText
                    primary='My Apps'
                    sx={{ '& .MuiTypography-root': { fontSize: '0.9rem', color: '#ffffff' } }}
                  />
                )}
              </StyledListItemButton>
            </Box>
          )}
        </>
      )}
    </Box>
  )

  return (
    <>
      <Snackbar
        open={Boolean(errorMessage)}
        onClose={handleErrorClose}
        autoHideDuration={6000}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <Alert severity='error' onClose={handleErrorClose} variant='filled' sx={{ borderRadius: '12px' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={Boolean(successMessage)}
        onClose={handleSuccessClose}
        autoHideDuration={6000}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <Alert severity='success' onClose={handleSuccessClose} variant='filled' sx={{ borderRadius: '12px' }}>
          {successMessage}
        </Alert>
      </Snackbar>

      <Dialog
        open={openLogoutDialog}
        onClose={() => setOpenLogoutDialog(false)}
        PaperProps={{ sx: { borderRadius: '12px', minWidth: '350px' } }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Confirm Logout</DialogTitle>
        <DialogContent>
          Are you sure you want to log out?
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setOpenLogoutDialog(false)} color="inherit" sx={{ textTransform: 'none' }}>
            Cancel
          </Button>
          <Button onClick={confirmLogout} variant="contained" color="error" sx={{ textTransform: 'none' }}>
            Logout
          </Button>
        </DialogActions>
      </Dialog>

      <Box sx={{ display: 'flex', pointerEvents: 'none', '& > *': { pointerEvents: 'auto' } }}>
        <CssBaseline />
        <AppBar position='fixed' open={open} sx={{ backgroundColor: '#ffffff', backgroundImage: 'none', borderBottom: `1px solid ${alpha('#000000', 0.1)}` }}>
          <Toolbar sx={{ px: { xs: 1, sm: 2 }, display: 'flex', justifyContent: 'space-between' }}>

            {/* Left Box (Menu & Title) */}
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              {!isMobileSearch || !showMobileSearch ? (
                <IconButton aria-label='toggle drawer' onClick={handleDrawerToggle} edge='start' sx={{ mr: 2, color: '#1e293b' }}>
                  <MenuIcon />
                </IconButton>
              ) : null}
              {(!isMobileSearch || !showMobileSearch) && (
                <Typography variant='h6' noWrap component='div' sx={{ fontWeight: 600, color: '#1e293b', fontSize: { xs: '1rem', sm: '1.1rem' }, mr: 3, display: { xs: 'none', md: 'block' } }}>
                  {pagename || sessionStorage.getItem('pageName') || 'Dashboard'}
                </Typography>
              )}
            </Box>

            {/* Center Box (Search Bar) */}
            <Box sx={{ display: 'flex', justifyContent: 'center', flex: isMobileSearch && showMobileSearch ? 1 : 2 }}>
              {!isMobileSearch || showMobileSearch ? (
                <Box sx={{ display: 'flex', flexGrow: 1, alignItems: 'center', width: '100%', maxWidth: '600px' }}>
                  <Autocomplete
                    size="small"
                    options={searchableMenus}
                    getOptionLabel={(option) => option.flatLabel}
                    sx={{
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: alpha('#f1f5f9', 0.6),
                        '& fieldset': { borderColor: 'transparent' },
                        '&:hover fieldset': { borderColor: alpha('#3b82f6', 0.2) },
                        '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="What would you like to do today?"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <Maticons.Search fontSize="small" sx={{ color: '#64748b' }} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        handleClick(newValue, newValue.index, 'menu', newValue.name)
                      }
                    }}
                  />
                  {isMobileSearch && (
                    <IconButton onClick={() => setShowMobileSearch(false)} sx={{ ml: 1, color: '#64748b' }}>
                      <Maticons.Close />
                    </IconButton>
                  )}
                </Box>
              ) : (
                <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
                  <IconButton onClick={() => setShowMobileSearch(true)} sx={{ color: '#64748b' }}>
                    <Maticons.Search />
                  </IconButton>
                </Box>
              )}
            </Box>

            {/* Right Box (Icons) */}
            {(!isMobileSearch || !showMobileSearch) && (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', flex: 1, gap: { xs: 0.5, sm: 1 } }}>
                <Tooltip title='Vendor Portal'>
                  <IconButton onClick={() => window.open('https://vp-dev.d1qtjia2b8rdgu.amplifyapp.com/', '_blank')} sx={{ color: '#64748b' }}>
                    <Maticons.Storefront />
                  </IconButton>
                </Tooltip>

                <Tooltip title='Switch Organization'>
                  <IconButton onClick={handleSwitchOrg} sx={{ color: '#64748b' }}>
                    <Maticons.CorporateFare />
                  </IconButton>
                </Tooltip>

                <Tooltip title='Refresh'>
                  <IconButton onClick={refreshPage} sx={{ color: '#64748b' }}>
                    <CachedIcon />
                  </IconButton>
                </Tooltip>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '4px 4px',
                    borderRadius: '12px',
                    transition: 'all 0.2s',
                    '&:hover': {
                      backgroundColor: alpha('#3b82f6', 0.05)
                    }
                  }}
                  onClick={handleMenu}
                >
                  <Tooltip title={`${userData.USR_Name} (${localStorage.getItem('tenant_id') || 'Current Org'})`} placement='bottom'>
                    <AvatarGroup
                      max={2}
                      sx={{
                        '& .MuiAvatar-root': {
                          width: 38,
                          height: 38,
                          fontSize: '0.9rem',
                          fontWeight: 700,
                          border: '2px solid #ffffff',
                          borderRadius: '10px',
                          boxShadow: `0 4px 10px ${alpha('#233067', 0.15)}`,
                          marginLeft: '-8px !important'
                        }
                      }}
                    >
                      <Avatar
                        src={ApiConstants.externals.serverUrl + 'api/user/getUserAvatar?USR_imageUrl=' + userData.USR_imageUrl}
                        alt={userData.USR_Name || 'User'}
                        sx={{ bgcolor: userData.USR_Name ? globalhelper.stringToColor(userData.USR_Name) : '#ccc' }}
                      >
                        {userData.USR_Name ? userData.USR_Name.charAt(0).toUpperCase() : 'U'}
                      </Avatar>
                      <Avatar
                        src={`${ApiConstants.externals.serverUrl}api/user/getTenantAvatar?fileName=${localStorage.getItem('Image')}`}
                        alt={localStorage.getItem('tenant_id') || 'Tenant'}
                        sx={{ bgcolor: '#f1f5f9' }}
                      >
                        {localStorage.getItem('tenant_id') ? localStorage.getItem('tenant_id').charAt(0).toUpperCase() : 'T'}
                      </Avatar>
                    </AvatarGroup>
                  </Tooltip>
                </Box>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleCloseAnc}
                  transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                  anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  PaperProps={{
                    sx: {
                      mt: 1.5, borderRadius: '12px', boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
                      '& .MuiMenuItem-root': { fontSize: '0.9rem', px: 2, py: 1, borderRadius: '8px', mx: 1, my: 0.5 }
                    }
                  }}
                >
                  <MenuItem onClick={handleOpen}>Change Password</MenuItem>
                  <MenuItem onClick={logout}>Logout</MenuItem>
                </Menu>
              </Box>
            )}
          </Toolbar>
        </AppBar>


        <Box component='nav' sx={{ width: { sm: open ? drawerWidth : 72 }, flexShrink: { sm: 0 } }}>
          {/* Mobile Drawer */}
          <MuiDrawer
            variant='temporary'
            open={mobileOpen}
            onClose={handleDrawerToggleMobile}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: drawerWidth,
                background: '#0f172a',
                color: '#94a3b8',
                border: 'none',
                boxShadow: '10px 0 30px rgba(0,0,0,0.2)'
              },
            }}
          >
            <DrawerHeader sx={{ borderBottom: `1px solid ${alpha('#ffffff', 0.1)}`, mb: 0 }}>
              {/* <Box
                component='img'
                src={DataTwin_Logo_}
                sx={{
                  height: 48,
                  filter: 'brightness(0) invert(1)',
                  px: 2
                }}
              /> */}
              <Typography variant="h5" sx={{ fontWeight: 900, color: '#fff', letterSpacing: '-1.5px', px: 2, display: 'flex', alignItems: 'center' }}>
                Agentic<Box component="span" sx={{ color: '#6366f1', ml: 0.5 }}>Finance</Box>
              </Typography>
            </DrawerHeader>
            {drawer}
          </MuiDrawer>

          {/* Desktop Drawer */}
          <Drawer variant='permanent' open={open}>
            <DrawerHeader sx={{ minHeight: 72, borderBottom: `1px solid ${alpha('#ffffff', 0.1)}` }}>
              {open ? (
                // <Box component='img' src={DataTwin_Logo_} sx={{ height: 48, filter: 'brightness(0) invert(1)', px: 1 }} />
                <Typography variant="h5" sx={{ fontWeight: 900, color: '#fff', letterSpacing: '-1.5px', px: 1, display: 'flex', alignItems: 'center' }}>
                  Agentic<Box component="span" sx={{ color: '#6366f1', ml: 0.5 }}>Finance</Box>
                </Typography>
              ) : (
                // <Box component='img' src={DatatwinIcon} sx={{ width: 28, filter: 'brightness(0) invert(1)' }} />
                <Typography variant="h6" sx={{ fontWeight: 900, color: '#6366f1', letterSpacing: '-1px' }}>
                  A
                </Typography>
              )}
            </DrawerHeader>
            {drawer}
          </Drawer>
        </Box>


        <Box
          component='main'
          sx={{
            flexGrow: 1,
            p: 2,
            width: { sm: `calc(100% - ${open ? drawerWidth : 72}px)` },
            height: 'calc(100vh - 64px)',
            mt: '64px',
            backgroundColor: '#f1f5f9', // Clean light background
            overflowY: 'auto',
            transition: theme.transitions.create(['width', 'margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen
            }),
            boxSizing: 'border-box'
          }}
        >
          {props.children}
        </Box>

        <Modal open={openDialog} onClose={handleClose}>
          <Box sx={{
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            width: 400, bgcolor: 'background.paper', borderRadius: '16px', boxShadow: 24, p: 4
          }}>
            <Typography variant='h6' sx={{ mb: 3, fontWeight: 700, color: '#1e293b' }}>Change Password</Typography>
            <TextField
              label='Old Password'
              type={password.visibility.oldOPassword ? 'text' : 'password'}
              fullWidth
              margin='normal'
              value={password.oldPassword}
              onChange={e => onPasswordChange('oldPassword', e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={() => onVisibilityChange('oldOPassword')}>
                      {password.visibility.oldOPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              label='New Password'
              type={password.visibility.newPassword ? 'text' : 'password'}
              fullWidth
              margin='normal'
              value={password.newPassword}
              onChange={e => onPasswordChange('newPassword', e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={() => onVisibilityChange('newPassword')}>
                      {password.visibility.newPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <TextField
              label='Confirm New Password'
              type={password.visibility.confirmNewPassword ? 'text' : 'password'}
              fullWidth
              margin='normal'
              value={password.confirmNewPassword}
              onChange={e => onPasswordChange('confirmNewPassword', e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton onClick={() => onVisibilityChange('confirmNewPassword')}>
                      {password.visibility.confirmNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Button onClick={handleClose} sx={{ color: '#64748b' }}>Cancel</Button>
              <LoadingButton
                variant='contained'
                onClick={handleChangePassword}
                loading={password.loading}
                disabled={password.invalid}
                sx={{ borderRadius: '8px', textTransform: 'none', px: 3 }}
              >
                Update Password
              </LoadingButton>
            </Box>
          </Box>
        </Modal>

        <ORGDialogbox
          open={showOrgModal}
          onClose={() => setShowOrgModal(false)}
        />
      </Box>
    </>
  )
}




const mapStateToProps = state => {
  return {
    state
  }
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  //   actions: login_actions,
}

// connect(mapStateToProps /** no second argument */)(ResponsiveDrawer)
// export default ResponsiveDrawer;

export default connect(mapStateToProps, {
  logout,
  navUrl,
  flushChatbotItems
})(ResponsiveDrawer)
